import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { DateTime } from 'luxon';

import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';
import { usePagination } from 'src/common/DataGrid/usePagination';
import {
  DaysOfWeekEnum,
  useRoutesRouteTemplatesListQuery,
} from 'src/common/external/bambi-api/routesApi';
import { orderDays } from 'src/features/trip/routeTemplates/management/DayOfTheWeekCell';

import { columns } from './columns';

export const RouteTemplatesDataGrid = () => {
  const search = useAppSelector((state) => state.routeTemplates.filterSearch);
  const defaultDriverIn = useAppSelector(
    (state) => state.routeTemplates.filterDriver
  );
  const daysOfWeek = useAppSelector(
    (state) => state.routeTemplates.filterDaysOfWeek
  );
  const filterRangeStart = useAppSelector(
    (state) => state.routeTemplates.filterRangeStart
  );
  const filterRangeEnd = useAppSelector(
    (state) => state.routeTemplates.filterRangeEnd
  );

  const { data, isLoading, isFetching, refetch } =
    useRoutesRouteTemplatesListQuery({
      name: search,
      defaultDriverIn,
      daysOfWeek: orderDays(daysOfWeek as DaysOfWeekEnum[]).join(','),
      activeAfter: filterRangeStart
        ? DateTime.fromISO(filterRangeStart).toSQLDate()
        : undefined,
      activeBefore: filterRangeEnd
        ? DateTime.fromISO(filterRangeEnd).toSQLDate()
        : undefined,
    });

  const { pagination, handlePaginationChange } = usePagination(refetch);
  if (isLoading || isFetching) {
    return (
      <div className="flex items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <DataGrid
      columns={columns}
      data={data?.results ?? []}
      tableId="route-templates"
      pagination={pagination}
      totalCount={data?.count}
      handlePaginationChange={handlePaginationChange}
      rowSelection={{}}
      getRowId={(row) => row.id}
      containerClassName="max-h-[600px]"
      emptyState={
        <div className="flex items-center justify-center">
          No route templates found
        </div>
      }
      enableGridScrolling
    />
  );
};
